import Vue from 'vue';

Vue.mixin({
  methods: {
    orderProcess() {
      return new Promise(async (resolve, reject) => {
        if (this.tmpOrder) {
          const loader = this.$loading.show();

          try {
            const response = await this.axios.post(
                `v2/order/${this.tmpOrder.id}`);

            if (response && response.data) {
              if (response.data.success) {
                localStorage.setItem('orderId', response.data.data.order_num);
                resolve(response.data.data.order_num);
              } else {
                reject(response.data.message);
              }
            }

            loader.hide();
          } catch (e) {
            reject(e);
            loader.hide();
          }
        }
      });
    },
    async checkoutAuthProcess(order) {
      if (order.flags && order.flags.coupons_enabled) {
        this.$store.dispatch('SET_COUPONS_ENABLED', order.flags.coupons_enabled);
      }

      if (order.flags && order.flags.contains_only_downloads) {
        if (!this.checkout.paymentOption) {
          await this.$store.dispatch('INIT_PAYMENT_OPTIONS');
        }

        if (this.checkout.paymentOption || +order.data.grandtotal === 0) {
          this.$store.dispatch('SET_CHECKOUT_STEP', 6);
        } else {
          const nextStep = this.$store.getters.COUPONS_ENABLED ? 2 : 3;
          this.$store.dispatch('SET_CHECKOUT_STEP', this.checkoutStep + nextStep);
        }
      } else {
        await this.$store.dispatch('INIT_SHIPPING_OPTIONS', {
          order_id: order.data.id,
        });

        this.$store.dispatch('SET_CHECKOUT_STEP', this.checkoutStep + 1);
      }
    },
    async checkPaymentStatus() {
      const path = this.$router.currentRoute.path.split('/');

      if (path[path.length - 1] === 'success' || path[path.length - 2] === 'success') {
        const orderId = await localStorage.getItem('orderId');
        await this.$router.push(this.i18nLink(`complete/order/${orderId}`));
        localStorage.removeItem('orderId');
      }

      if (path[path.length - 1] === 'abort') {
        this.toast(this.$t('error'), this.$t('messages.payment_canceled'), 'danger');
        this.$router.push(this.i18nLink('checkout'));
      }
    },
  },
});
